/**
 * Keeps supermarketPayments in sync with expense records (expense_payment rows).
 */
import { setCachedExpensesRead } from '../../utils/expensesReadSource';

export function syncExpensePaymentsFromExpenses(expenses, prevPayments) {
  const safePayments = Array.isArray(prevPayments) ? prevPayments : [];
  const safeExpenses = Array.isArray(expenses) ? expenses : [];

  const nonExpensePayments = safePayments.filter(
    (payment) => payment?.transactionType !== 'expense_payment'
  );

  const existingExpensePaymentByRef = new Map(
    safePayments
      .filter((payment) => payment?.transactionType === 'expense_payment' && payment?.referenceId)
      .map((payment) => [String(payment.referenceId), payment])
  );

  const syncedExpensePayments = safeExpenses
    .filter((expense) => expense && expense.id)
    .map((expense) => {
      const referenceId = String(expense.id);
      const existing = existingExpensePaymentByRef.get(referenceId);
      const amount = Number(expense.amount) || 0;
      const nowIso = new Date().toISOString();

      return {
        ...existing,
        id: existing?.id || `PAY_EXP_${referenceId}`,
        amount,
        totalAmount: amount,
        paymentMethod: expense.paymentMethod || existing?.paymentMethod || 'cash',
        electronicPaymentMethod:
          expense.electronicPaymentMethod || existing?.electronicPaymentMethod || null,
        fundingSource: expense.fundingSource || existing?.fundingSource,
        registerPortion: expense.registerPortion ?? existing?.registerPortion,
        externalPortion: expense.externalPortion ?? existing?.externalPortion,
        paymentType: existing?.paymentType || 'full_payment',
        status: 'paid',
        transactionType: 'expense_payment',
        referenceId,
        supplierId: expense.supplierId || null,
        workerId: expense.workerId || existing?.workerId || null,
        workerName: expense.workerName || existing?.workerName || null,
        actorRole: expense.actorRole || existing?.actorRole || null,
        paymentDate: expense.date || existing?.paymentDate || nowIso,
        notes: expense.description?.trim()
          ? `Expense: ${expense.description}`
          : existing?.notes || 'Expense payment',
        createdAt: existing?.createdAt || expense.createdAt || nowIso,
        updatedAt: nowIso
      };
    });

  return [...nonExpensePayments, ...syncedExpensePayments];
}

/** Sync payments + warm expenses read cache (Écart beim Kassierer-Logout). */
export function syncExpensePaymentsFromExpensesWithCache(expenses, prevPayments, businessId) {
  const syncedPayments = syncExpensePaymentsFromExpenses(expenses, prevPayments);
  if (businessId) {
    setCachedExpensesRead(businessId, expenses);
  }
  return syncedPayments;
}
